import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/location-item", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/location-item/csv", params);
};

const upsert = data => {
  return restApi.post("/api/location-item/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/location-item/${ids}`);
};

const bulkValueUpdate = data => {
  return restApi.post("/api/location-item/bulk-value-update", data);
};

// 재고계획 대상 거점-품목 조합 수 — { count } (홈 파이프라인 "재고계획" 단계용, COUNT 집계만)
const getIpTargetCount = () => {
  return restApi.get("/api/location-item/ip-target-count");
};

// 보충계획 대상 거점-품목 조합 수 — { count } (홈 파이프라인 "보충계획" 단계용, COUNT 집계만)
const getRpTargetCount = () => {
  return restApi.get("/api/location-item/rp-target-count");
};

// 생산계획 대상 거점-품목 조합 수 — { count } (홈 파이프라인 "생산계획" 단계용, COUNT 집계만)
const getMpTargetCount = () => {
  return restApi.get("/api/location-item/mp-target-count");
};

// 안전재고 미설정 조합 — { missingCount, missing:[{locCd,locName,itemCd,itemName}] } (홈 "안전재고 설정" 카드용)
const getSafetyStockMissing = () => {
  return restApi.get("/api/location-item/safety-stock-missing");
};

const locationItemService = {
  getAll,
  getIpTargetCount,
  getRpTargetCount,
  getMpTargetCount,
  getSafetyStockMissing,
  getAllForCSV,
  upsert,
  remove,
  bulkValueUpdate
};

export default locationItemService;